import {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
    ReactElement,
} from 'react'

type Breakpoint = 'md' | 'lg' | 'xl'

const BreakpointContextInstance = createContext<Breakpoint>('lg')

export const useBreakpointContext = (): Breakpoint =>
    useContext(BreakpointContextInstance)

export const BreakpointContextProvider = ({
    children,
}: {
    children: ReactNode
}): ReactElement => {
    const [breakpoint, setBreakpoint] = useState<Breakpoint>('lg')

    useEffect(() => {
        const onResize = (): void => {
            const width = window.innerWidth
            if (width < 1400) {
                setBreakpoint('md')
            } else if (width < 1550) {
                setBreakpoint('lg')
            } else {
                setBreakpoint('xl')
            }
        }
        onResize()
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])

    return (
        <BreakpointContextInstance.Provider value={breakpoint}>
            {children}
        </BreakpointContextInstance.Provider>
    )
}
